var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.226mm",
    height: "7.44mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 233.41 154.69",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.31,
    width: 224.17,
    height: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 2.31,
    y: 150.07,
    width: 224.17,
    height: 4.62
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 91.1754 53.9981)",
    width: 4.62,
    height: 70.8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 91.1754 100.756)",
    width: 70.8,
    height: 4.62
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993350181232"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    x: 64.2,
    y: 75.04,
    width: 105.24,
    height: 4.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993350183680"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M200.4 110.63c-0.09,-0 -0.19,-0 -0.28,-0 -18.38,0 -33.28,-14.9 -33.28,-33.28 0,-18.38 14.9,-33.28 33.28,-33.28 18.38,0 33.28,14.9 33.28,33.28 0,0.09 0,0.18 0,0.27 -0.18,18.15 -14.85,32.83 -33,33.01l0 0zm0 -61.94c-15.83,0 -28.66,12.83 -28.66,28.66 0,15.82 12.83,28.66 28.66,28.66 15.83,0 28.66,-12.83 28.66,-28.66 0,-15.83 -12.83,-28.66 -28.66,-28.66l0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993350181424"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M33.28 110.63c-18.38,-0 -33.28,-14.91 -33.28,-33.28 0,-18.38 14.9,-33.28 33.28,-33.28 18.38,0 33.28,14.9 33.28,33.28 0,0.09 0,0.18 0,0.27 -0.18,18.26 -15.02,32.98 -33.28,33.01l0 0zm0 -61.94c-15.82,0 -28.66,12.83 -28.66,28.66 0,15.82 12.83,28.66 28.66,28.66 15.83,0 28.66,-12.83 28.66,-28.66 -0.03,-15.82 -12.85,-28.63 -28.66,-28.66l-0 0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc24);
export default __webpack_public_path__ + "static/media/ic_2_4.36e6af2479fe783ce5f069b0f55c8698.svg";
export { ForwardRef as ReactComponent };